import React, { useEffect } from 'react';
import { Link, useOutletContext } from 'react-router-dom';

import { StateLanguage } from '../../../languages/config/StateLanguage';
import { useUpgradeModal } from '../../../contexts/UpgradeModalContext';

export interface PayrollAccessDeniedProps {
  reason?: 'role' | 'plan' | 'status';
}

const PayrollAccessDenied: React.FunctionComponent<PayrollAccessDeniedProps> = ({ reason }) => {
  const { lang } = StateLanguage();
  const ctx: any = useOutletContext();
  const { openUpgradeModal } = useUpgradeModal();

  const isPlanDenial = reason === 'plan' || reason === 'status';

  useEffect(() => {
    ctx?.setRoute?.({path: {root: lang.labels.payroll, branch: lang.labels.payrollAccessDenied}, company: false})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="card">
      <div className="card-body p-10 text-center">
        <div className="mb-8">
          <span className={`svg-icon svg-icon-5x ${isPlanDenial ? 'svg-icon-warning' : 'svg-icon-danger'}`}>
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" fill="currentColor" opacity="0.3"/>
              <path d="M12 7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1zm0 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" fill="currentColor"/>
            </svg>
          </span>
        </div>
        <h2 className="fw-bolder mb-5">{lang.labels.payrollAccessDenied}</h2>
        <p className="text-muted fw-bold fs-6 mb-3">
          {isPlanDenial
            ? lang.labels.payrollAccessDeniedPlanRequired
            : lang.labels.payrollAccessDeniedOwnerOnly}
        </p>
        {!isPlanDenial && (
          <p className="text-muted fw-bold fs-6 mb-8">
            {lang.labels.payrollAccessDeniedReconnect}
          </p>
        )}
        <div className="d-flex justify-content-center gap-3 mt-8">
          <Link to="/main/dashboard" className="btn btn-primary">
            {lang.labels.backToDashboard}
          </Link>
          {isPlanDenial && (
            <button
              type="button"
              className="btn btn-light-primary"
              onClick={() => openUpgradeModal('payroll')}
            >
              {lang.labels.subscriptionUpgradePlan}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PayrollAccessDenied;
